/**
 * detectAiPageContext — derives { current_page, customer_id, job_id } from a
 * URL pathname so the assistant's server prompt has the right grounding.
 *
 * Kept as a pure path-parsing function (no window reads) so callers pass a
 * live pathname from useLocation() — keeps it testable and SSR-safe.
 */
export default function detectAiPageContext(path) {
  const p = path || '';
  if (p.startsWith('/log-job/')) {
    const parts = p.split('/');
    return { current_page: 'log_job', customer_id: parts[2] || null, job_id: null };
  }
  if (p.startsWith('/jobs/')) {
    const parts = p.split('/');
    return { current_page: 'job_detail', customer_id: null, job_id: parts[2] || null };
  }
  if (p.includes('/route') || p.includes('/schedule')) {
    return { current_page: 'route', customer_id: null, job_id: null };
  }
  if (p.includes('/invoice')) {
    return { current_page: 'invoices', customer_id: null, job_id: null };
  }
  if (p.includes('/estimate')) {
    return { current_page: 'estimates', customer_id: null, job_id: null };
  }
  if (p === '/' || p.includes('/dashboard') || p.includes('/home')) {
    return { current_page: 'dashboard', customer_id: null, job_id: null };
  }
  return { current_page: 'other', customer_id: null, job_id: null };
}
